export const FETCH_IMAGE_SLIDERS_LIST = 'IMAGE_SLIDERS/FETCH_IMAGE_SLIDERS_LIST';
export const FETCH_IMAGE_SLIDERS_LIST_ERROR = 'IMAGE_SLIDERS/FETCH_IMAGE_SLIDERS_LIST_ERROR';
export const CLEAR_FETCH_IMAGE_SLIDERS_LIST = 'IMAGE_SLIDERS/CLEAR_FETCH_IMAGE_SLIDERS_LIST';

export const FETCH_IMAGE_SLIDER_DETAILS_SUCCESS = 'IMAGE_SLIDERS/FETCH_IMAGE_SLIDER_DETAILS_SUCCESS';
export const FETCH_IMAGE_SLIDER_DETAILS_ERROR = 'IMAGE_SLIDERS/FETCH_IMAGE_SLIDER_DETAILS_ERROR';
export const CLEAR_FETCH_IMAGE_SLIDER_DETAILS = 'IMAGE_SLIDERS/CLEAR_FETCH_IMAGE_SLIDER_DETAILS';

export const APPLY_IMAGE_SLIDER_DRAG_SUCCESS = 'IMAGE_SLIDERS/APPLY_IMAGE_SLIDER_DRAG_SUCCESS';
export const APPLY_IMAGE_SLIDER_DRAG_ERROR = 'IMAGE_SLIDERS/APPLY_IMAGE_SLIDER_DRAG_ERROR';
export const CLEAR_IMAGE_SLIDER_DRAG = 'IMAGE_SLIDERS/CLEAR_IMAGE_SLIDER_DRAG';

export const ADD_IMAGE_SLIDER_SUCCESS = 'IMAGE_SLIDERS/ADD_IMAGE_SLIDER_SUCCESS';
export const ADD_IMAGE_SLIDER_ERROR = 'IMAGE_SLIDERS/ADD_IMAGE_SLIDER_ERROR';
export const CLEAR_ADD_IMAGE_SLIDER = 'IMAGE_SLIDERS/CLEAR_ADD_IMAGE_SLIDER';

export const PATCH_IMAGE_SLIDER_SUCCESS = 'IMAGE_SLIDERS/PATCH_IMAGE_SLIDER_SUCCESS';
export const PATCH_IMAGE_SLIDER_ERROR = 'IMAGE_SLIDERS/PATCH_IMAGE_SLIDER_ERROR';
export const CLEAR_PATCH_IMAGE_SLIDER = 'IMAGE_SLIDERS/CLEAR_PATCH_IMAGE_SLIDER';

export const DELETE_IMAGE_SLIDER_SUCCESS = 'IMAGE_SLIDERS/DELETE_IMAGE_SLIDER_SUCCESS';
export const DELETE_IMAGE_SLIDER_ERROR = 'IMAGE_SLIDERS/DELETE_IMAGE_SLIDER_ERROR';
export const CLEAR_DELETE_IMAGE_SLIDER = 'IMAGE_SLIDERS/CLEAR_DELETE_IMAGE_SLIDER';

export const ADD_IMAGES_SUCCESS = 'IMAGE_SLIDERS/ADD_IMAGES_SUCCESS';
export const ADD_IMAGES_ERROR = 'IMAGE_SLIDERS/ADD_IMAGES_ERROR';
export const CLEAR_ADD_IMAGES = 'IMAGE_SLIDERS/CLEAR_ADD_IMAGES';

export const DELETE_IMAGES_SUCCESS = 'IMAGE_SLIDERS/DELETE_IMAGES_SUCCESS';
export const DELETE_IMAGES_ERROR = 'IMAGE_SLIDERS/DELETE_IMAGES_ERROR';
export const CLEAR_DELETE_IMAGES = 'IMAGE_SLIDERS/CLEAR_DELETE_IMAGES';

export const VERIFY_INSTAGRAM_ACCOUNT_SUCCESS = 'IMAGE_SLIDERS/VERIFY_INSTAGRAM_ACCOUNT_SUCCESS';
export const VERIFY_INSTAGRAM_ACCOUNT_ERROR = 'IMAGE_SLIDERS/VERIFY_INSTAGRAM_ACCOUNT_ERROR';
export const CLEAR_VERIFY_INSTAGRAM_ACCOUNT = 'IMAGE_SLIDERS/CLEAR_VERIFY_INSTAGRAM_ACCOUNT';

export const PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS = 'IMAGE_SLIDERS/PATCH_DETAILS_FOR_IMAGE_SLIDER_SUCCESS';
export const PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR = 'IMAGE_SLIDERS/PATCH_DETAILS_FOR_IMAGE_SLIDER_ERROR';
export const CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER = 'IMAGE_SLIDERS/CLEAR_PATCH_DETAILS_FOR_IMAGE_SLIDER';
